// extracted by mini-css-extract-plugin
module.exports = {"bannerClickBox":"index-module_bannerClickBox_18-z8","customeThemeImg":"index-module_customeThemeImg_3wiAN"};